import { AxiosResponse } from 'axios';
import { useSelector } from 'react-redux';

import { createServiceInstance } from '../baseService';
import {
  ILoadDraftRequest,
  ILoadDraftResponse,
  ISaveDraftRequest,
  ISaveDraftResponse
} from './draftServiceTypes';

/**
 * Draft service model
 *
 * @description Returns object with user services
 * @typedef {object} IDraftService
 */
export interface IDraftService {
  saveFormDraft: (request: ISaveDraftRequest) => Promise<AxiosResponse<ISaveDraftResponse>>;
  loadFormDraft: (request: ILoadDraftRequest) => Promise<AxiosResponse<ILoadDraftResponse>>;
}

/**
 * User service hook
 * @description Gives access to all services relating to user
 */
const useDraftService = () : IDraftService => {
  const token = useSelector((state: any) => state.B2CSettings.items.accesstokenForms);
  const webappurlFormsApi = useSelector((state: any) => state.B2CSettings.items.webappurlFormsApi);

  const getInstance = () => createServiceInstance(`${webappurlFormsApi}/api/myCASA/Forms`, token);

  /**
   * Save Form Draft
   *
   * @description Save draft from to cosmos
   * @param {ISaveDraftRequest} request Save draft request
   * @returns {Promise<AxiosResponse<ISaveDraftResponse>>} Draft axios response
   */
  const saveFormDraft = (request: ISaveDraftRequest): Promise<AxiosResponse<ISaveDraftResponse>> => {
    const axiosInstance = getInstance();

    // Encode the formdata as it is a requirement for the existing service
    request.formData = btoa(request.formData);

    return axiosInstance.post<ISaveDraftResponse>('/SaveDraft/v1', request);
  };

  /**
   * Load Form Draft
   *
   * @description Load draft form from Cosmos
   * @param {ILoadDraftRequest} request Load draft request'
   * @returns {Promise<AxiosResponse<ILoadDraftResponse>>} Draft axios response
   */
  const loadFormDraft = (request: ILoadDraftRequest): Promise<AxiosResponse<ILoadDraftResponse>> => {
    const axiosInstance = getInstance();

    return axiosInstance.post<ILoadDraftResponse>('/LoadDraft/v1', request);
  };

  return {
    saveFormDraft,
    loadFormDraft
  };
};

export default useDraftService;